module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Lia DeFrancesca handed her passport over to the customs officer, watching as he squinted and held it up to the light.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Name?” he asked in English.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Li Shanken.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Business or pleasure?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Business.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He frowned. Before he could ask any more questions, Lia handed him a letter on fancy UN letterhead explaining in Spanish that she was an employee of Complete Computing on loan to the U.S.-based election consultant firm FairPlay International, which had been retained to assist the election commission overseeing Peru’s presidential election this coming Sunday. The man read the letter twice, then shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is there a problem?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Go,” he told her, mumbling something under his breath as he handed the documents back.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hello, Lia,” said Rockman in her ear. “We can see you through the airport’s security system. Your UN escort is waiting at the end of the hall. We think he’s Julio Fernandez, the security liaison for the election committee, but we haven’t gotten a good shot of him yet. Make sure to verify his identity with the retina scan.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lia spotted a twenty-something man holding a sign with her name on it a few yards away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m Li Shanken,” she told him in English, pointing to the sign. “From FairPlay.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He blinked twice, his wire-rimmed glasses nearly falling off his nose. Tall and thin, he towered over Lia, though he probably weighed less than she did.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes,” he said. “Oh.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You were expecting a man?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, no.” He pushed his glasses up on his nose.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not all computer experts are men,” said Lia.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, I knew—I thought you would be an older woman, not one so beautiful.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He covered that well,” snickered Rockman.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where’s your car?” asked Lia.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I came by taxi,” he said, starting for the door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Please get a retina scan to confirm his identity,” said Rockman. “And listen, with the taxis, use the official ones at the kiosk. The independents can’t always be trusted.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That was the thing with the Art Room. They were always looking over your shoulder, playing mother hen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Of course, the one time she’d actually needed them to help her, they were nowhere to be found.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not entirely true and definitely not fair, she thought as she followed Fernandez outside. But being raped tended to change your perspective on both truth and fairness.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The UN official waded out onto the pavement, ducking a succession of vehicles. He waved at an empty taxi, which ignored him, then practically stood in the middle of the road for another. It didn’t stop because it already had a passenger.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let’s try over here,” said Lia, starting to the right.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Lia, what happened to the retina scan?” asked Rockman. “Don’t get into the cab with him until you’re sure. One hundred percent "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sure")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As Fernandez walked to a car that had just pulled up, Lia feinted for it, then sprinted to the one stuck behind it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, wait,” she said, ducking away and going to a third car, which was back by the curb. Her maneuver would not only cross up any arrangement Fernandez had with an accomplice waiting to kidnap her, but it also allowed her to see how he reacted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His confused look and shrug told her more than the retina scan ever could. She did the scan anyway, opening the case and seeing to her makeup as Fernandez slid in next to her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So what do you think?” Lia asked him, tilting the faux mirror toward him. “We should be at National Trust in what, two hours, give or take, depending on traffic?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You want to get right to work?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No sense dallying. We can drop off the luggage at the hotel on the way.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Dean and Tommy are right behind you,” said Rockman. “Next time, though, stick with the program, OK? Some of these taxi drivers are scam artists.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t worry,” sighed Lia, leaning back against the seat.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Worry?” said Fernandez.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What is there to worry about, except the traffic?” Lia said to him. “Do you mind if I practice my Spanish? It’s rusty. Your English is so good.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His face brightened. “As I come from Spain, my Spanish here is too stiff,” he said. “Between American Spanish and peninsular Spanish, there is a difference.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mine is basically from high school,” said Lia, skipping the months of intense language training she’d taken in the Army. “"), _c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "Images/excl.jpg",
      "width": "5"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hola, Julio!")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“"), _c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "Images/excl.jpg",
      "width": "5"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hola, Li!")]), _vm._v("” Fernandez laughed. “My first lesson in English was ‘Hello’ as well.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“All right, he checks out,” said Rockman.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Gracias.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Muy bien")]), _vm._v(",” said Fernandez, thinking she was talking to him. “As you wish.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc476210","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781429954921_ch03.vue
// module id = 75
// module chunks = 0